import { Navigate, useLocation } from 'react-router-dom';
import { useIdentity } from 'context/identity-provider';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

// UX gate only — the bundle is public. Real protection is the API's Cognito authorizer.
// No user-id check: self sign-up is disabled on the pool, so any valid session is the one user.
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, redirectTo = '/login' }) => {
  const { isAuth, isLoading } = useIdentity();
  const location = useLocation();

  if (isLoading) return null;
  return isAuth
    ? <>{children}</>
    : <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
};

export default ProtectedRoute;
